{
  "common": {
    "ok": "OK",
    "cancel": "Cancelar",
    "yes": "Sim",
    "no": "Não",
    "loading": "Carregando...",
    "error": "Erro",
    "retry": "Tentar novamente",
    "apply": "Aplicar",
    "add": "Adicionar"
  },
  "navigation": {
    "home": "Início",
    "favorites": "Favoritos",
    "search": "Buscar"
  },
  "jobs": {
    "noJobs": "Nenhum trabalho encontrado",
    "loadMore": "Carregar mais",
    "apply": "Aplicar",
    "save": "Salvar",
    "unsave": "Remover"
  },
  "search": {
    "placeholder": "Buscar trabalhos...",
    "filter": "Filtrar",
    "clear": "Limpar",
    "open": "Pesquisar trabalhos",
    "close": "Fechar busca"
  },
  "alerts": {
    "title": "Alertas de vagas",
    "subtitle": "Receba uma notificação quando surgirem vagas que combinem com sua busca.",
    "placeholder": "Palavras-chave (ex. react remoto sênior)",
    "empty": "Nenhum alerta ainda",
    "matchingNow": "{{count}} combinam agora"
  },
  "description": {
    "openUrlMessage": "Abrir URL para mais informações",
    "postedOn": "Publicado em",
    "applyViewDetails": "Aplicar / Ver detalhes"
  },
  "error": {
    "title": "Algo deu errado",
    "description": "Desculpe, nenhum trabalho encontrado! Provavelmente é um erro de servidor ou rede.",
    "tryAgain": "Tentar novamente"
  },
  "filter": {
    "refineJobs": "Refinar trabalhos",
    "title": "Filtrar",
    "total": "total",
    "reset": "Redefinir",
    "filterByDate": "Filtrar por data",
    "byDate": "Por Data",
    "byApplied": "Por Aplicadas",
    "appliedOnlyOn": "Somente aplicadas: ativado",
    "appliedOnlyOff": "Somente aplicadas: desativado",
    "postedAfter": "Publicado após",
    "filterByTags": "Filtrar por tags",
    "byTag": "Por Tag",
    "clearAllFavorites": "Limpar todos os favoritos",
    "applyFilters": "Aplicar filtros"
  },
  "share": {
    "message": "Segue uma grande oportunidade de trabalho remoto:\n* Posição: {{position}}\n* Empresa: {{company}}\n* URL: {{url}}",
    "title": "App de Trabalho Remoto - {{position}} @{{company}}",
    "subject": "Trabalho compartilhado do App de Trabalho Remoto",
    "dialogTitle": "Compartilhar um trabalho remoto"
  },
  "datepicker": {
    "selectDate": "Selecionar Data",
    "year": "Ano",
    "month": "Mês",
    "previousMonth": "Mês anterior",
    "nextMonth": "Próximo mês",
    "weekdays": [
      "Dom",
      "Seg",
      "Ter",
      "Qua",
      "Qui",
      "Sex",
      "Sáb"
    ],
    "months": [
      "Janeiro",
      "Fevereiro",
      "Março",
      "Abril",
      "Maio",
      "Junho",
      "Julho",
      "Agosto",
      "Setembro",
      "Outubro",
      "Novembro",
      "Dezembro"
    ]
  },
  "tabs": {
    "allJobs": "Todos os Trabalhos",
    "favorites": "Favoritos",
    "resumeBuilder": "Currículo",
    "applications": "Candidaturas",
    "profile": "Perfil"
  },
  "favorites": {
    "deleteAll": "Excluir todos os Favoritos",
    "empty": "Nenhum favorito ainda. Toque no coração de uma vaga para salvá-la aqui."
  },
  "icons": {
    "jobActions": "Ações do Trabalho",
    "addToFavorites": "Adicionar aos Favoritos",
    "removeFromFavorites": "Remover dos Favoritos",
    "share": "Compartilhar",
    "openUrl": "Abrir URL",
    "markApplied": "Marcar como Aplicado",
    "removeApplied": "Remover Aplicado"
  },
  "job": {
    "applied": "Aplicado",
    "fit": "Afinidade {{score}}%"
  },
  "list": {
    "found": "encontrados"
  },
  "onboarding": {
    "tagline": "Descubra oportunidades remotas selecionadas de todo o mundo!",
    "next": "Próximo"
  },
  "tour": {
    "skip": "Pular",
    "next": "Próximo",
    "getStarted": "Começar",
    "slides": {
      "welcome": {
        "title": "Boas-vindas",
        "description": "Um tour rápido pelos principais recursos para você encontrar sua próxima vaga remota mais rápido."
      },
      "search": {
        "title": "Buscar e filtrar vagas",
        "description": "Busque por palavra-chave e refine os resultados por data, tags ou status de candidatura."
      },
      "favorites": {
        "title": "Favoritos e vagas aplicadas",
        "description": "Toque no coração para salvar vagas e marque as que você já se candidatou."
      },
      "tracker": {
        "title": "Acompanhe suas candidaturas",
        "description": "Marque vagas como aplicadas e acompanhe cada uma por etapas — entrevista, oferta — com notas e datas."
      },
      "alerts": {
        "title": "Receba alertas de novas vagas",
        "description": "Salve uma busca e receba uma notificação quando surgirem vagas remotas que combinem com suas palavras-chave."
      },
      "resume": {
        "title": "Monte seu currículo",
        "description": "Crie um currículo profissional, exporte como PDF ou DOCX e veja o quanto cada vaga combina com suas habilidades."
      },
      "account": {
        "title": "Entre para sincronizar",
        "description": "Crie uma conta grátis para guardar seus currículos, candidaturas, favoritos e alertas em todos os aparelhos."
      },
      "settings": {
        "title": "Temas e idiomas",
        "description": "Alterne entre claro e escuro e escolha entre 9 idiomas nas configurações."
      }
    }
  },
  "theme": {
    "toggle": "Alternar tema"
  },
  "settings": {
    "title": "Configurações",
    "theme": "Tema",
    "themeLight": "Claro",
    "themeDark": "Escuro",
    "language": "Idioma",
    "open": "Abrir configurações",
    "close": "Fechar",
    "developer": "Desenvolvedor",
    "hideAds": "Ocultar anúncios",
    "removeAds": {
      "title": "Remover Anúncios",
      "buy": "Remover anúncios — {{price}}",
      "restore": "Restaurar compras",
      "purchased": "Obrigado por apoiar o RemoteWork! Os anúncios estão desativados.",
      "successTitle": "Anúncios removidos",
      "successMessage": "Obrigado pelo apoio! Os anúncios agora estão desativados em todo o app.",
      "errorTitle": "Falha na compra",
      "errorMessage": "Algo deu errado. Tente novamente.",
      "restoreEmptyTitle": "Nada para restaurar",
      "restoreEmptyMessage": "Nenhuma compra anterior foi encontrada nesta conta."
    },
    "tour": "Tour",
    "replayTour": "Refazer o tour",
    "account": "Conta",
    "deleteAccount": {
      "action": "Excluir conta",
      "confirmTitle": "Excluir conta?",
      "confirmMessage": "Isso exclui permanentemente sua conta e todos os dados sincronizados — currículos, candidaturas, favoritos e alertas. Não dá para desfazer.",
      "errorTitle": "Não foi possível excluir a conta",
      "errorMessage": "Algo deu errado. Tente novamente.",
      "reauthMessage": "Por segurança, saia e entre novamente, depois tente excluir sua conta."
    },
    "about": "Sobre",
    "privacyPolicy": "Política de privacidade",
    "website": "Visitar o site"
  },
  "ad": {
    "sponsored": "Patrocinado"
  },
  "consent": {
    "message": "Usamos cookies de análise para entender como o site é utilizado. Ficam desativados até que você aceite.",
    "accept": "Aceitar",
    "reject": "Recusar"
  },
  "disclaimer": {
    "title": "Sobre as vagas exibidas",
    "message": "As vagas exibidas neste aplicativo vêm de fontes de terceiros e APIs públicas. Nós não publicamos, selecionamos nem controlamos esses anúncios e não podemos garantir a precisão, a qualidade ou a disponibilidade de nenhuma vaga. Confirme sempre os detalhes diretamente com o empregador antes de se candidatar.",
    "okCountdown": "OK ({{seconds}})"
  },
  "resume": {
    "title": "Construtor de Currículos",
    "newResume": "Novo",
    "newResumePrompt": "Dê um nome ao seu currículo",
    "namePlaceholder": "Ex.: CV Frontend",
    "lastModified": "Última edição",
    "discardTitle": "Descartar alterações?",
    "discardMessage": "Você tem edições não salvas.",
    "webPlaceholder": {
      "title": "O Construtor de Currículos é exclusivo para celular",
      "subtitle": "Abra o aplicativo no Android ou iOS para criar e exportar seu currículo."
    },
    "actions": {
      "edit": "Editar",
      "duplicate": "Duplicar",
      "delete": "Excluir",
      "more": "Mais opções",
      "deleteConfirmTitle": "Excluir currículo?",
      "deleteConfirmMessage": "Excluir definitivamente \"{{name}}\"? Esta ação não pode ser desfeita."
    },
    "empty": {
      "title": "Nenhum currículo ainda",
      "subtitle": "Monte um currículo profissional e exporte em PDF ou DOCX.",
      "cta": "Criar meu primeiro currículo",
      "skillsHint": "Adicione habilidades como JavaScript, design, liderança…"
    },
    "sections": {
      "personalInfo": "Dados pessoais",
      "experience": "Experiência",
      "education": "Educação",
      "skills": "Habilidades",
      "languages": "Idiomas",
      "links": "Links",
      "template": "Modelo",
      "contact": "Contato",
      "summary": "Resumo",
      "personalization": "Personalização",
      "preview": "Pré-visualizar"
    },
    "fields": {
      "fullName": "Nome completo",
      "title": "Cargo profissional",
      "email": "E-mail",
      "phone": "Telefone",
      "location": "Localização",
      "website": "Site",
      "summary": "Resumo profissional",
      "company": "Empresa",
      "position": "Cargo",
      "institution": "Instituição",
      "degree": "Diploma",
      "field": "Área de estudo",
      "startDate": "Início",
      "endDate": "Término",
      "current": "Trabalho aqui atualmente",
      "present": "Atual",
      "description": "Descrição",
      "skillPlaceholder": "Adicionar habilidade",
      "languageName": "Idioma",
      "languageProficiency": "Nível",
      "linkLabel": "Rótulo",
      "linkUrl": "URL",
      "phoneCountryCode": "Código do país"
    },
    "proficiency": {
      "basic": "Básico",
      "conversational": "Conversação",
      "fluent": "Fluente",
      "native": "Nativo"
    },
    "templates": {
      "modern": "Moderno",
      "classic": "Clássico",
      "minimal": "Minimalista",
      "modernDescription": "Layout em duas colunas com barra lateral colorida.",
      "classicDescription": "Tradicional em preto e branco, coluna única.",
      "minimalDescription": "Limpo, com bastante espaço em branco e sem cor."
    },
    "buttons": {
      "addExperience": "Adicionar experiência",
      "addEducation": "Adicionar educação",
      "addLanguage": "Adicionar idioma",
      "addLink": "Adicionar link",
      "remove": "Remover",
      "save": "Salvar",
      "discard": "Descartar",
      "export": "Exportar",
      "exportPdf": "Exportar em PDF",
      "exportDocx": "Exportar em DOCX",
      "create": "Criar",
      "previous": "Anterior",
      "next": "Próximo"
    },
    "export": {
      "preparing": "Preparando seu arquivo…",
      "preparingHint": "Escolha um formato. O arquivo abrirá no menu de compartilhamento.",
      "errorTitle": "Falha na exportação",
      "errorMessage": "Algo deu errado ao exportar seu currículo."
    },
    "validation": {
      "invalidEmail": "Informe um e-mail válido.",
      "invalidCountryCode": "Use até 4 dígitos, opcionalmente com + no início.",
      "invalidWebsite": "Informe um site válido (ex.: exemplo.com)."
    },
    "personalization": {
      "title": "Personalizar",
      "colorMode": "Tema de cores",
      "modes": {
        "light": "Claro",
        "dark": "Escuro"
      },
      "fontFamily": "Fonte",
      "fonts": {
        "sans": "Sem serifa",
        "serif": "Com serifa",
        "modern": "Moderna",
        "mono": "Mono"
      },
      "fontSize": "Tamanho da fonte",
      "sizes": {
        "title": "Título",
        "subtitle": "Subtítulo",
        "body": "Texto"
      },
      "increase": "Aumentar {{field}}",
      "decrease": "Diminuir {{field}}"
    },
    "photo": {
      "placeholder": "Sem foto",
      "choose": "Adicionar foto",
      "change": "Trocar foto",
      "remove": "Remover",
      "permissionTitle": "Permissão necessária",
      "permissionMessage": "Permita acesso à galeria para escolher uma foto de perfil."
    }
  },
  "sort": {
    "recent": "Mais recentes",
    "bestFit": "Melhor afinidade",
    "toggle": "Ordenar por afinidade"
  },
  "applyKit": {
    "title": "Kit de candidatura",
    "hint": "Toque para copiar e colar no formulário.",
    "copied": "Copiado",
    "openExternal": "Abrir no navegador"
  },
  "applications": {
    "title": "Candidaturas",
    "empty": {
      "title": "Nenhuma candidatura ainda",
      "subtitle": "As vagas em que você se candidatar aparecem aqui para acompanhar o status."
    },
    "status": {
      "applied": "Apliquei",
      "interviewing": "Entrevista",
      "offer": "Oferta",
      "rejected": "Recusado"
    },
    "notesPlaceholder": "Adicionar notas…",
    "remove": "Remover",
    "removeConfirm": "Remover esta candidatura?",
    "lastUpdate": "Última atualização: {{date}}",
    "editDate": "Editar data",
    "addManual": "Adicionar candidatura"
  },
  "auth": {
    "account": "Conta",
    "signIn": "Entrar",
    "signUp": "Criar conta",
    "signOut": "Sair",
    "title": {
      "signIn": "Bem-vindo de volta",
      "signUp": "Crie sua conta"
    },
    "email": "E-mail",
    "password": "Senha",
    "showPassword": "Mostrar senha",
    "hidePassword": "Ocultar senha",
    "forgotPassword": "Esqueci minha senha?",
    "resetSent": "E-mail de redefinição enviado — confira sua caixa de entrada.",
    "enterEmailFirst": "Digite seu e-mail primeiro.",
    "noAccount": "Não tem conta? Crie uma",
    "haveAccount": "Já tem conta? Entrar",
    "criteria": {
      "minLength": "Pelo menos 8 caracteres",
      "uppercase": "Uma letra maiúscula",
      "lowercase": "Uma letra minúscula",
      "numeric": "Um número",
      "special": "Um caractere especial"
    },
    "errors": {
      "invalid-email": "Esse e-mail parece inválido.",
      "invalid-credential": "E-mail ou senha incorretos.",
      "user-not-found": "Nenhuma conta encontrada com esse e-mail.",
      "wrong-password": "E-mail ou senha incorretos.",
      "email-already-in-use": "Já existe uma conta com esse e-mail.",
      "weak-password": "Essa senha não atende aos requisitos.",
      "requires-recent-login": "Entre novamente para continuar.",
      "too-many-requests": "Muitas tentativas. Tente mais tarde.",
      "network": "Erro de rede. Verifique sua conexão.",
      "not-configured": "Login indisponível no momento.",
      "unknown": "Algo deu errado. Tente novamente."
    },
    "continueGoogle": "Continuar com Google",
    "continueApple": "Continuar com Apple",
    "or": "ou",
    "loggedInAnonymous": "Conectado como anônimo",
    "continueAnonymous": "Continuar como anônimo",
    "loggedOutWarning": "Você não está logado — seus dados ficam só neste aparelho e podem ser perdidos."
  },
  "profile": {
    "title": "Perfil",
    "signInRegister": "Entrar / Cadastrar",
    "more": "Mais"
  },
  "applyBrowser": {
    "title": "Candidatar-se"
  }
}
